export const isIOS = () => {
  const userAgentCheck = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const platformCheck = ["iPhone", "iPad", "iPod"].includes(navigator.platform);

  return userAgentCheck || platformCheck;
};